(function($){

    function apiService(){
        //this.apiURL = 'http://www.msspotweldingapi.local/v1';
        this.apiURL = 'https://api.mssoldaduraporpunto.com/v1';
        this.apiURLCategories = this.apiURL + '/categories';
        this.apiURLProducts = this.apiURL + '/products';
        this.apiURLFeaturedProducts = this.apiURL + '/products/featured';
    }

    apiService.prototype.getCategories = function(){
        var that = this;
        return new Promise(
            function (resolve, reject) {
                $.ajax({
                    type : 'GET',
                    url  : that.apiURLCategories,
                    data : '',
                    dataType : 'json',
                    encode : true
                }).done(function (res) {
                    resolve(res);
                }).fail(function (data) {
                    // for debug
                    reject(data);
                });
            }
        );
    };

    apiService.prototype.getProductById = function(productId){
        var that = this;
        return new Promise(
            function (resolve, reject) {
                $.ajax({
                    type : 'GET',
                    url  : that.apiURLProducts + '/' + productId,
                    data : '',
                    dataType : 'json',
                    encode : true
                }).done(function (res) {
                    resolve(res);
                }).fail(function (data) {
                    // for debug
                    reject(data);
                });
            }
        );
    };

    apiService.prototype.getProducts = function(categoryId){
        var that = this;
        var url = this.apiURLProducts;
        if(categoryId){
            url += '?category_id=' + categoryId;
        }
        return new Promise(
            function (resolve, reject) {
                $.ajax({
                    type : 'GET',
                    url  : url,
                    data : '',
                    dataType : 'json',
                    encode : true
                }).done(function (res) {
                    resolve(res);
                }).fail(function (data) {
                    // for debug
                    reject(data);
                });
            }
        );
    };

    apiService.prototype.getFeaturedProducts = function(){
        var url = this.apiURLFeaturedProducts;
        return new Promise(
            function (resolve, reject) {
                $.ajax({
                    type : 'GET',
                    url  : url,
                    data : '',
                    dataType : 'json',
                    encode : true
                }).done(function (res) {
                    resolve(res);
                }).fail(function (data) {
                    // for debug
                    reject(data);
                });
            }
        );
    };

    // Export
    window.apiService = apiService;

}($));


(function(apiService) {
    function contactCtrl() {
        var contactMessageDOMSelector = 'contact-message';
        var contactMessageLabelDOMSelector = 'contact-message-label';

        // DOM Binding
        this.contactMessage = document.getElementById(contactMessageDOMSelector);
        this.contactMessageLabel = document.getElementById(contactMessageLabelDOMSelector);

        this.api = new apiService();
    }


    contactCtrl.prototype.setContactMessage = function(productId){
        console.log(this.contactMessage);
        // Hola, quiero consultar sobre este producto CONTROLES DE MEDIA FRECUENCIA.
        if(!productId){
            return;
        }
        var that = this;
        this.api.getProductById(productId).then(function(res){
            that.contactMessageLabel.innerText = ''; // Clean

            that.contactMessage.value = 'Hola, quiero consultar sobre este producto ';
            that.contactMessage.value += '"' + res.data.title + '"';
            that.contactMessage.value += ' [https://mssoldaduraporpunto.com/es/producto/' + productId + '].';

        }).catch(function(err){
            console.log(err);
        });
    };
    // Export
    window.contactCtrl = contactCtrl;
}(window.apiService));

// Execute
var contactCtrl = new contactCtrl();

